import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, of, Subject, Subscription } from 'rxjs';
import { debounceTime, filter, map, switchMap, tap, take } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';
import { PlantService } from '../../../../../core/plant-configuration/_services/plant.service';
import { AuthService, Profiles, selectAllProfiles, selectLastCreatedUserId, selectUserById, User, UserOnServerCreated, UserUpdated } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import * as CryptoJS from 'crypto-js';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../../core/reducers';
import { selectAuthState } from '../../../../../core/auth/_selectors/auth.selectors';
import { AllProfilesRequested } from '../../../../../core/auth/_actions/profile.actions';
import { ActivatedRoute } from '@angular/router';
import { Update } from '@ngrx/entity';
import { OperatorService } from '../../../../../core/plant-configuration/_services/operator.service';

@Component({
	selector: 'kt-user-edit',
	templateUrl: './user-edit.component.html',
	styleUrls: []
})
export class UserEditComponent implements OnInit, OnDestroy, AfterViewInit {
	itemObs = new BehaviorSubject<any>(null);
	editObs = new Subject<number>();
	addObs = new Subject<number>();
	showPage = true;
	private itemFormOptions = {
		login: ["", Validators.required],
		password_crypt: ["",],
		group_id: ["1",],
		is_operator: [0],
		// company_id: ["-1", Validators.required],
	};
	private itemFormNotOperatorOptions = {
		login: ["", Validators.required],
		password_crypt: ["",],
		group_id: ["1",],
		is_operator: [0],
		// company_id: ["-1", Validators.required],
	};
	private itemFormNewOperatorOptions = {
		login: ["", Validators.required],
		password_crypt: ["",],
		group_id: ["1",],
		is_operator: [1],
		operator_id: [-1],
		name: ["", Validators.required],
		email: ["", Validators.email],
		mobile: [""],
		street: [""],
		website: [""],
		rut: [""]
		// company_id: ["-1", Validators.required],
	};
	private itemFormExistingOperatorOptions = {
		login: ["", Validators.required],
		password_crypt: ["",],
		group_id: ["1",],
		is_operator: [0],
		operator_id: [-1],
		// company_id: ["-1", Validators.required],
	};
	itemForm = this.formBuilder.group(this.itemFormExistingOperatorOptions);
	stepListNotOperator: any[] = [
		{
			icon: "flaticon2-architecture-and-city", title: "Configuración de planta", subTitle: "Ingrese datos de contacto", form: [
				[
					{ name: "login", label: "Usuario", type: "text" },
					{ name: "password_crypt", label: "Contraseña", type: "password" },
				],
				[
					{ name: "group_id", label: "Perfil", type: "list", optionList: [] },
					{ name: "is_operator", label: "Es operador?", type: "checkbox", value: 0, text: "Es operador?"}
				],
				// [
				//   { name: "company_id", label: "Empresa", type: "list", optionList: []},
				// ]
			]
		},
	];
	stepListExistingOperator: any[] = [
		{
			icon: "flaticon2-architecture-and-city", title: "Configuración de planta", subTitle: "Ingrese datos de contacto", form: [
				[
					{ name: "login", label: "Usuario", type: "text" },
					{ name: "password_crypt", label: "Contraseña", type: "password" },
				],
				[
					{ name: "group_id", label: "Perfil", type: "list", optionList: [] },
					{ name: "is_operator", label: "Es operador?", type: "checkbox", value: 1, text: "Es operador?"}
				],
				[
				  	{ name: "operator_id", label: "Operador", type: "list", optionList: []},
				]
			]
		},
	];
	stepListNewOperator: any[] = [
		{
			icon: "flaticon2-architecture-and-city", title: "Configuración de planta", subTitle: "Ingrese datos de contacto", form: [
				[
					{ name: "login", label: "Usuario", type: "text" },
					{ name: "password_crypt", label: "Contraseña", type: "password" },
				],
				[
					{ name: "group_id", label: "Perfil", type: "list", optionList: [] },
					{ name: "is_operator", label: "Es operador?", type: "checkbox", value: 1, text: "Es operador?"}
				],
				[
					{ name: "operator_id", label: "Operador", type: "list", optionList: []},
			  	]
			]
		},
		{
			icon: "flaticon2-user-outline-symbol", title: "Datos del operador", subTitle: "Ingrese datos del operador", form: [
				[
				  { name: "name", label: "Nombre", type: "text" },
				  { name: "email", label: "Email", type: "text" },
				],
				[
				  { name: "mobile", label: "Celular", type: "text"},
				  { name: "street", label: "Dirección", type: "text"},
				],
				[
					{ name: "rut", label: "Rut", type: "text"},
					{ name: "website", label: "Sitio web", type: "text"},
				],	
			]
		},
	];
	stepList:any[] = this.stepListExistingOperator;


	private subscriptions: Subscription[] = [];
	data: any = {};
	partnerList: any[];
	userList: any[];
	uid: number = -1;
	company: any = null;
	currentUser: any;
	profilesResult: Profiles[];
	user: User;

	constructor(
		private plantService: PlantService,
		// private companyService: CompanyService,
		private authService: AuthService,
		private formBuilder: FormBuilder,
		private store: Store<AppState>,
		private activatedRoute: ActivatedRoute,
		private cdr: ChangeDetectorRef,
		private operatorService: OperatorService,
	) { }

	ngOnInit() {
		this.uid = this.authService.getUID();

		const authSubscription = this.store.pipe(
			select(selectAuthState),
		).subscribe((auth) => {
			// console.log("auth state: "+JSON.stringify(auth));
			if (auth.isUserLoaded)
				this.currentUser = auth.user;
			else
				console.log("shift edit component: usuario no logueado");
			// this.subscriptions.push(
			//     of(null).pipe(
			//         switchMap(()=>this.companyService.companyLoaded$),
			//         filter((companyLoaded)=>companyLoaded==true)
			//     ).subscribe((companyLoaded)=>{
			//       if(companyLoaded){
			//         this.company = this.companyService.getCurrentCompany();
			//       }
			//         // this.stepList[0].form[1][0].optionList = companyList.map(company=>{return{text:company.name, value:company.id}})
			//         // this.data.companyList = companyList;
			//     })
			// )
			const profiles$ = this.store.pipe(
				select(selectAllProfiles)
			);
			const profilesSub = profiles$.subscribe(
				(profiles) => {
					// console.log(`user group id: ${this.currentUser.group_id}`)
					// console.log("profiles before");console.dir(profiles);
					if (this.currentUser.group_id == 1) {
						profiles = profiles.filter(profile => [1, 2, 3].includes(profile.id));
					}
					console.log("profiles: ");console.dir(profiles);
					this.profilesResult = profiles;
					this.stepList[0].form[1][0].optionList = this.profilesResult.map(profile => {
						return { value: profile.id, text: profile.name }
					});
					this.stepListExistingOperator[0].form[1][0].optionList = this.stepList[0].form[1][0].optionList;
					this.stepListNewOperator[0].form[1][0].optionList = this.stepList[0].form[1][0].optionList;
					this.stepListNotOperator[0].form[1][0].optionList = this.stepList[0].form[1][0].optionList;
					
					if((this.user == undefined || this.user.id == undefined) && profiles.length>0){
						this.itemForm.controls.group_id.patchValue(`${this.profilesResult[0].id}`);	
					}
					this.data.groupList = this.profilesResult;
					// console.log("profilesSub: "+JSON.stringify(profiles));
					// if (profiles && this.itemForm && profiles.length > 0) {
					// 	this.itemForm.get("group_id").patchValue(profiles[0].id);

					// }
					this.cdr.detectChanges();
				}

			)
			this.subscriptions.push(profilesSub);

			const operatorSub = of(null).pipe(
				switchMap(()=>this.operatorService.getAll()),
				map(operatorList=>operatorList.filter(operator=>operator.user_id == null))
			).subscribe(operatorList=>{
				console.log('operator list:');console.dir(operatorList);
				if(operatorList.length > 0){
					this.stepListExistingOperator[0].form[2][0].optionList = [{
						value: -1,
						text: 'Nuevo operador'
					}].concat(operatorList.map(operator=>{
						return {
							text: operator.name,
							value: operator.id
						}
					}));
					
				}else{
					this.stepListExistingOperator[0].form[2][0].optionList = [{
						value: -1,
						text: 'Nuevo operador'
					}]
				}
				if(this.user['operator_id']!=undefined && 
					this.stepListExistingOperator[0].form[2][0].optionList.find(op=>op.value == this.user['operator_id'])==undefined){
					this.stepListExistingOperator[0].form[2][0].optionList.push({
						value: this.user['operator_id'],
						text: this.user['name']
					})
				}
				this.stepListNewOperator[0].form[2][0].optionList = this.stepListExistingOperator[0].form[2][0].optionList;
			})
			this.subscriptions.push(operatorSub);
			this.loadProfiles();
			
			const routeSubscription =  this.activatedRoute.params.subscribe(params => {
				//console.table(params);
				const id = params.id;
				if (id && id > 0) {
					this.store.pipe(select(selectUserById(id))).subscribe(res => {
						console.table("res: "+JSON.stringify(res));
						if (res) {
							let user = new User();
							user.clear();
							user = Object.assign(user, res);
							this.itemForm.controls.login.patchValue(user.login);
							console.dir({user})
							console.log("patching group id from component")
							// this.itemForm.controls.group_id.patchValue(`${user['group_id_']}`);
							user.group_id = `${user['group_id_']}`;
							this.itemForm.controls.group_id.patchValue(user.group_id);
							// setTimeout(()=>{
							// 	this.itemForm.controls.group_id.patchValue(`${user['group_id_']}`);
							// }, 1000)
							this.itemObs.next(user);
							this.user = user;

							if(this.user['operator_id']!=undefined && 
								this.stepListExistingOperator[0].form[2][0].optionList.find(op=>op.value == this.user['operator_id'])==undefined){
								this.stepListExistingOperator[0].form[2][0].optionList.push({
									value: this.user['operator_id'],
									text: this.user['name']
								})
							}
							this.cdr.detectChanges();
						}
					});
				} else {
					this.user = new User();
					this.user.clear();
				}
			});
			this.subscriptions.push(routeSubscription);
		});
		this.subscriptions.push(authSubscription);

		this.watchIsOperator();
	}

	getFormValues = ()=>{
		return Object.keys(this.itemForm.controls).map(ctrl=>{
			return {
				value: this.itemForm.controls[ctrl].value,
				name: ctrl
			}
		});
	}

	getFormValuesObj = ()=>{
		return this.itemForm.value;
	}

	applyFormValues = (values)=>{
		Object.keys(this.itemForm.controls).forEach(ctrl=>{
			const value = values.find(val=>val.name == ctrl);
			if(value){
				this.itemForm.controls[ctrl].patchValue(value.value);
			}
		})
	}

	applyUserValuesToForm(){
		if(this.user){
			// this.itemObs.next(this.user);
			Object.keys(this.itemForm.controls).forEach(key=>{
				if(this.user[key]!=undefined) this.itemForm.controls[key].patchValue(this.user[key]);
			})
		}
	}

	watchIsOperator(){
		// const sub = combineLatest([
			const sub = this.itemForm.controls.is_operator.valueChanges
			// of(null).pipe(
			// 	switchMap(()=>this.operatorService.getAll()),
			// 	map(operatorList=>operatorList.filter(operator=>operator.user_id == null))
			// ),
		// ])
		.pipe(
			tap(()=>{this.showPage=false}),
			debounceTime(100),
			take(1)
		).subscribe((is_operator)=>{
			if(is_operator){
				// console.log('operator list:');console.dir(operatorList);
				// if(operatorList.length > 0){
				// 	this.stepListExistingOperator[0].form[2][0].optionList = [{
				// 		value: -1,
				// 		text: 'Nuevo operador'
				// 	}].concat(operatorList.map(operator=>{
				// 		return {
				// 			text: operator.name,
				// 			value: operator.id
				// 		}
				// 	}));
					
				// }else{
				// 	this.stepListExistingOperator[0].form[2][0].optionList = [{
				// 		value: -1,
				// 		text: 'Nuevo operador'
				// 	}]
				// }
				// if(this.user['operator_id']!=undefined){
				// 	this.stepListExistingOperator[0].form[2][0].optionList.push({
				// 		value: this.user['operator_id'],
				// 		text: this.user['name']
				// 	})
				// }

				

				const values = this.getFormValues();
				this.stepList = this.stepListNewOperator;
				this.itemForm = this.formBuilder.group(this.itemFormNewOperatorOptions);
				this.applyUserValuesToForm();
				this.applyFormValues(values);

				this.watchOperatorId();
			}else{
				console.log("not stonks")
				const values = this.getFormValues();
				console.dir(values);
				this.stepList = this.stepListNotOperator;
				this.itemForm = this.formBuilder.group(this.itemFormNotOperatorOptions);
				this.applyUserValuesToForm();
				this.applyFormValues(values);
			}
			this.showPage = true;
			this.cdr.detectChanges();

			sub.unsubscribe();
			this.subscriptions.filter(sub_=>sub_!=sub);

			this.itemForm.controls.is_operator.patchValue(is_operator);
			this.watchIsOperator();
		});
		this.subscriptions.push(
			sub
		);
	}

	watchOperatorId(){
		const sub = this.itemForm.controls.operator_id.valueChanges.pipe(
			tap(()=>{this.showPage = false;}),
			debounceTime(100),
			take(1)
		).subscribe((operator_id)=>{
			const values = this.getFormValues();
			if(operator_id == -1){
				this.stepList = this.stepListNewOperator;
				this.itemForm = this.formBuilder.group(this.itemFormNewOperatorOptions);
			}else{
				this.stepList = this.stepListExistingOperator;
				this.itemForm = this.formBuilder.group(this.itemFormExistingOperatorOptions);
			}
			this.applyUserValuesToForm();
			this.applyFormValues(values);
			this.showPage = true;
			this.cdr.detectChanges();
			sub.unsubscribe();
			this.subscriptions.filter(sub_=>sub_!=sub);
			this.watchIsOperator();

			this.itemForm.controls.operator_id.patchValue(operator_id);
			this.watchOperatorId();
		});
		this.subscriptions.push(sub);
	}
	loadProfiles() {
		this.store.dispatch(new AllProfilesRequested());
	}
	ngAfterViewInit() {

	}
	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	onItemLoaded(item) {

		console.log("on item load:");
	}

	getItem(itemId: number) {
		if(this.user != undefined && itemId == this.user.id){
			this.onItemLoaded(this.user);
			this.itemObs.next(this.user);
		}
		// this.subscriptions.push(
		// 	of(null).pipe(
		// 		switchMap(() => this.plantService.getById(itemId))
		// 	).subscribe(item => {
		// 		this.onItemLoaded(item);
		// 		this.itemObs.next(item);
		// 	})
		// )
	}

	addItem(item: any) {
		// item.create_uid = this.uid>0?this.uid:'null';
		// item.create_date = "now()";
		// item.is_installation_contact = 'true';
		item.write_uid = this.uid > 0 ? this.uid : 'null';
		item.password_crypt = CryptoJS.MD5(item.password_crypt).toString();;
		// item.active = 'true';
		// this.subscriptions.push(
		//   of(null).pipe(
		//     switchMap(() => this.plantService.add(item))
		//   ).subscribe(newId => {
		//     this.addObs.next(newId);
		//   })
		// )
		this.store.dispatch(new UserOnServerCreated({ user: item }));
		const addSubscription = this.store.pipe(select(selectLastCreatedUserId)).subscribe(newId => {
			this.addObs.next(newId ? Number(newId) : 0);
			if (!newId) return;
		});
		this.subscriptions.push(addSubscription);
	}

	editItem(item: any) {
		item.id = this.user.id;
		item.write_uid = this.uid > 0 ? this.uid : 'null';
		console.log(`encripyting ${item.password_crypt}`)
		console.dir({editedItem: item});
		const rawPassword = item.password_crypt;
		console.log(`raw password: ${rawPassword}`)
		if(rawPassword == '' || rawPassword == null){
			delete item.password_crypt;
		}else{
			item.password_crypt = CryptoJS.MD5(rawPassword).toString();
			console.log(`encrypted: ${item.password_crypt}`)
		}		
		
		// item.write_date = "now()";
		// item.is_installation_contact = 'true';
		// this.subscriptions.push(
		// 	of(null).pipe(
		// 		switchMap(() => this.plantService.edit(item))
		// 	).subscribe(status => {
		// 		if (status == "success") this.editObs.next(item.id);
		// 		else this.editObs.next(-1);
		// 	})
		// )
		const user = Object.assign({}, item);
		const updatedUser: Update<User> = {
			id: item.id,
			changes: user
		};
		item.password_crypt = rawPassword;
		this.store.dispatch(new UserUpdated( { partialUser: updatedUser, user: user }));
		setTimeout(()=>{
			this.editObs.next(user.id);
		}, 200)
		
		// const message = `El usuario ha sido actualizado con exito.`;
		// this.layoutUtilsService.showActionNotification(message, MessageType.Update, 5000, true, true);
		// if (withBack) {
		// 	this.goBackWithId();
		// } else {
		// 	this.refreshUser(false);
		// }
	}
}
